var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.5 0.5C4.97715 0.5 0.5 4.97715 0.5 10.5C0.5 16.0228 4.97715 20.5 10.5 20.5C16.0228 20.5 20.5 16.0228 20.5 10.5C20.4936 4.97982 16.0202 0.506429 10.5 0.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2725 7.33337L10.5684 15.0742C10.4323 15.2547 10.2295 15.373 10.0054 15.4024C9.7813 15.4319 9.55478 15.3701 9.37671 15.2309L5.30338 11.9742C4.94393 11.6866 4.88573 11.162 5.17338 10.8025C5.46102 10.4431 5.9856 10.3849 6.34504 10.6725L9.74171 13.39L14.9309 6.34754C15.101 6.0922 15.3978 5.95103 15.7032 5.98007C16.0087 6.00912 16.2735 6.20368 16.3925 6.48652C16.5115 6.76935 16.4654 7.09469 16.2725 7.33337Z",
    fill: "#1A0DAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle1);
export default __webpack_public_path__ + "static/media/check-circle-1.65509732338067bce7e37d0928889b3e.svg";
export { ForwardRef as ReactComponent };